import { ContentfulDocumentPage } from 'components/content/ContentfulDocumentPage'
import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  const { t } = useTranslation()
  return <ContentfulDocumentPage metaTitle={t('common.cookie_policy')} slug="cookie-policy" />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx)) } }
}
